<template>
    <div>
        <!---<ServiceDashboard v-if="isService"></ServiceDashboard>--->
        <OperatorDashboard v-if="isOperator"></OperatorDashboard>
        <AdminDashboard v-if="isAdmin"></AdminDashboard>
    </div>
</template>
<script>


    import OperatorDashboard from "@/views/OperatorDashboard";
    import AdminDashboard from "@/views/AdminDashboard";


    export default {
    name: 'Main',
      data() {
      return {
        model: {
          data: '',
        }
      }
    },
        components: {AdminDashboard, OperatorDashboard},
        mounted() {
        if (this.$store.getters['authentication/isService']) {
            this.$router.push('/service');
        } else  {
            // enable multiple windows for non service users
            this.allowMultipleInstances();
        }
        },
        computed: {
            isService () {
                return this.$store.getters['authentication/isService'];
            },
            isOperator () {
                return this.$store.getters['authentication/isOperator'];
            },
            isAdmin () {
                return this.$store.getters['authentication/isAdmin'];
            }
        }
  };
</script>
